import Swiper from 'swiper';
import { A11y, Pagination } from 'swiper/modules';
Swiper.use([ A11y, Pagination]);

jQuery(document).ready(function() {
  if (jQuery('.swiper-usps').length) {
    new Swiper('.swiper-usps', {
      slidesPerView: 1,
      spaceBetween: 50,
      speed: 1000,
      a11y: {
        enabled: true,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        bulletElement: 'button',
      },
      breakpoints: {
        1199: {
          slidesPerView: 3,
          spaceBetween: 100,
        },
        991: {
          slidesPerView: 3,
          spaceBetween: 75,
        },
        767: {
          slidesPerView: 3,
          spaceBetween: 50,
        },
        575: {
          slidesPerView: 2,
          spaceBetween: 50,
        },
      },
    });
  }
});
